"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import Link from "next/link";
import { MOBILE_NAVIGATION_CONFIG } from "@/lib/navigation";
import { routes } from "@/lib/routes";
import { MobileAccordion } from "@/components/layout/navigation/MobileAccordion";
interface MobileNavigationProps {
  onItemClick: () => void;
}
export function MobileNavigation(t0) {
  const $ = _c(10);
  const {
    onItemClick
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [openSections, setOpenSections] = useState(t1);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = id => {
      setOpenSections(prev => prev.includes(id) ? prev.filter(s => s !== id) : [...prev, id]);
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const toggleSection = t2;
  let t3;
  if ($[2] !== onItemClick || $[3] !== openSections) {
    t3 = MOBILE_NAVIGATION_CONFIG.map(menu => <MobileAccordion key={menu.id} menu={menu} isOpen={openSections.includes(menu.id)} onToggle={() => toggleSection(menu.id)} onItemClick={onItemClick} />);
    $[2] = onItemClick;
    $[3] = openSections;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== onItemClick) {
    t4 = <div className="pt-6 space-y-4"><Link href={routes.content.ueberUns} onClick={onItemClick} className="block text-white/70 font-medium hover:text-neon transition-colors">Über uns</Link><Link href={routes.content.kontakt} onClick={onItemClick} className="block text-white/70 font-medium hover:text-neon transition-colors">Kontakt</Link></div>;
    $[5] = onItemClick;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t3 || $[8] !== t4) {
    t5 = <nav className="flex-1 space-y-0">{t3}{t4}</nav>;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}